import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { translate } from 'react-i18next';

import SimpleBox from '../../components/SimpleBox/';
import AppIcon from '../../components/AppIcon';

class ContinueConfirmation extends Component {
  constructor(props) {
    super(props);
    this.onContinue = this.onContinue.bind(this);
    this.onDeny = this.onDeny.bind(this);
  }

  onContinue() {
    this.props.confirmContinue();
  }

  onDeny() {
    this.props.logout();
  }

  render() {
    const { show, t } = this.props;

    const simpleBox = (
      <SimpleBox>
        <div className="box-header">
          <h1>{t('continueConfirmation.title')}</h1>
          <p>{t('continueConfirmation.message')}</p>
          <div className="confirm-continue-actions">
            <Button
              className="action-btn"
              onClick={() => this.onContinue()}
            >
              {t('continueConfirmation.continueButton')}
            </Button>
            <Button
              className="action-btn"
              onClick={() => this.onDeny()}
            >
              {t('logoutButton')}
            </Button>
          </div>
        </div>
      </SimpleBox>
    );

    return (
      <Modal
        className="continue-confirmation-screen"
        show={show}
        backdrop="static"
        keyboard={false}
      >
        <Button
          bsStyle="link"
          className="close-link basic-action-link"
          onClick={() => this.onDeny()}
        >
          <AppIcon iconName="CLOSE" containerClass="close-icon" />
        </Button>
        {simpleBox}
      </Modal>
    );
  }
}

ContinueConfirmation.propTypes = {
  show: PropTypes.bool.isRequired,
  confirmContinue: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

ContinueConfirmation.defaultProps = {};

export default translate(['booking'])(ContinueConfirmation);



// WEBPACK FOOTER //
// ./src/containers/ContinueConfirmation/ContinueConfirmation.jsx